import { ParsedMetricData } from '../../metrics';
import { IMetricWithSummaryData } from '../ServerApi/types/IMetricWithSummaryData';
import { IIdItem, ILuidItem, INamedItem } from '../ServerApi/types/resourceParts';
import { IUserInfo } from './IUserInfo';
import { IExplorableItemTypeInfo, IFavoriteItem, IUpdatedItemInfo } from './resourceInfoParts';

export interface IMetricInfo extends
    IExplorableItemTypeInfo<'metric'>,
    INamedItem,
    ILuidItem,
    IIdItem,
    IUpdatedItemInfo,
    IFavoriteItem {
  metricChanged: number;
  owner: IUserInfo;
  metricUpdated: Date;
  viewId: number;
  metricConnectedViewName: string;
  metricValue?: number;
  parsedData?: ParsedMetricData;
}

export function isMetricInfo(metric: IExplorableItemTypeInfo): metric is IMetricInfo {
  return (metric.contentType === 'metric');
}
